module.exports = __webpack_public_path__ + "static/media/big_smartsampa_logo_mobile_lightAlt.f344e3d6.png";